(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-tops"] && !Shopify.designMode) return;
  try {
    
/* Shopify t128 : ancres de l'introduction des pages de gamme (bloc « Liquid personnalisé » .md-ancres).
   Chaque lien vise l'identifiant de section Shopify ; s'il ne correspond pas, on cherche la section par sa clé
   (data-md-cible, ex. md_videos) ; section absente ou masquée : le lien est retiré. */
(function () {
  function regler() {
    document.querySelectorAll('.md-ancres [data-md-cible]').forEach(function (a) {
      var id = (a.getAttribute('href') || '').slice(1);
      var cible = id ? document.getElementById(id) : null;
      if (!cible) {
        cible = document.querySelector('[id^="shopify-section-"][id$="__' + a.getAttribute('data-md-cible') + '"]');
        if (cible) a.setAttribute('href', '#' + cible.id);
      }
      var li = a.closest('li');
      if (!cible || cible.getBoundingClientRect().height === 0) { if (li) li.remove(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', regler);
  else regler();
  document.addEventListener('shopify:section:load', regler);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-videos"] && !Shopify.designMode) return;
  try {
    
/* UX t113 : bloc vidéo de l'accueil. Ordinateur : lecture au survol sans le son ; téléphone : lecture de la carte la plus visible.
   Bouton son (même lecteur), bouton agrandir ou toucher : lecteur plein écran avec le son. Rien n'est chargé de YouTube avant. */
(function () {
  var BASE = 'https://www.youtube-nocookie.com/embed/';
  var survol = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function lecteur(id, muet, ctrl) {
    var f = document.createElement('iframe');
    f.src = BASE + id + '?autoplay=1&mute=' + (muet ? 1 : 0) + '&controls=' + (ctrl ? 1 : 0) + '&loop=1&playlist=' + id + '&playsinline=1&rel=0&modestbranding=1&enablejsapi=1';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.title = 'Vidéo YouTube';
    f.loading = 'lazy';
    return f;
  }
  function commande(f, func) { if (f && f.contentWindow) f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*'); }
  function arreter(c) {
    var f = c.querySelector('.md-vid__ecran iframe');
    if (f) f.remove();
    c.classList.remove('is-lecture');
    var s = c.querySelector('.md-vid__son'); if (s) s.setAttribute('aria-pressed', 'false');
  }
  function lancer(c) {
    if (c.querySelector('.md-vid__ecran iframe')) return;
    var f = lecteur(c.dataset.yt, true, false);
    f.addEventListener('load', function () { c.classList.add('is-lecture'); });
    c.querySelector('.md-vid__ecran').appendChild(f);
  }
  document.querySelectorAll('.md-vids').forEach(function (bloc) {
    var cartes = [].slice.call(bloc.querySelectorAll('.md-vid'));
    var dialog = bloc.querySelector('.md-vids__dialog');
    var cadre = dialog.querySelector('.md-vids__cadre');
    function agrandir(c) {
      cartes.forEach(arreter);
      cadre.innerHTML = '';
      cadre.appendChild(lecteur(c.dataset.yt, false, true));
      dialog.showModal();
    }
    dialog.addEventListener('close', function () { cadre.innerHTML = ''; });
    dialog.querySelector('.md-vids__fermer').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    cartes.forEach(function (c) {
      var t;
      if (survol) {
        c.addEventListener('pointerenter', function () { t = setTimeout(function () { lancer(c); }, 250); });
        c.addEventListener('pointerleave', function () { clearTimeout(t); arreter(c); });
        c.querySelector('.md-vid__ecran').addEventListener('click', function () { agrandir(c); });
      } else {
        c.querySelector('.md-vid__ecran').addEventListener('click', function () { agrandir(c); });
      }
      c.querySelector('.md-vid__agrandir').addEventListener('click', function () { agrandir(c); });
      c.querySelector('.md-vid__son').addEventListener('click', function () {
        lancer(c);
        var b = this, f = c.querySelector('.md-vid__ecran iframe');
        var on = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', on ? 'Couper le son' : 'Activer le son');
        setTimeout(function () { commande(f, on ? 'unMute' : 'mute'); }, f && c.classList.contains('is-lecture') ? 0 : 1200);
      });
    });
    // Téléphone et tablette : la carte la plus visible se lance sans le son, une seule à la fois
    if (!survol && 'IntersectionObserver' in window) {
      var parts = new Map();
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { parts.set(e.target, e.isIntersecting ? e.intersectionRatio : 0); });
        var meilleure = null, max = 0.6;
        parts.forEach(function (r, c) { if (r > max) { max = r; meilleure = c; } });
        cartes.forEach(function (o) { if (o !== meilleure) arreter(o); });
        if (meilleure) lancer(meilleure);
      }, { threshold: [0, 0.3, 0.6, 0.7, 0.8, 0.9, 1] });
      cartes.forEach(function (c) { io.observe(c); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
